import { css, SerializedStyles } from "@emotion/react"
import styled from "@emotion/styled"

import { FlexContainer } from "../../../../styled/flexbox.styled"
import { SCIENT_AGGRID_COLORS, SCIENT_COLORS } from "../../../../styled/scientColors"
import { MediumText, SmallText } from "../../../../styled/text.styled"
import { RowCell } from "../../../../styled/table.styled"
import { Side } from "./types/common"
import { getOrderSideBackgroundColor } from "./utils/sideStyle"

export const inputCss = (index: number): SerializedStyles =>
  css({
    width: "100%",
    height: "100%",
    padding: "0 10px",
    border: "none",
    borderRadius: "0",
    backgroundColor:
      index % 2 === 0 //to have different one row out of two
        ? SCIENT_AGGRID_COLORS.defaultRowBackground
        : SCIENT_AGGRID_COLORS.altRowBackground,
  })

export const bp5InputCss = (index: number): SerializedStyles =>
  css({
    ".bp5-input": {
      boxShadow: "none",
      borderRadius: "0",
      backgroundColor:
        index % 2 === 0 //to have different one row out of two
          ? SCIENT_AGGRID_COLORS.defaultRowBackground
          : SCIENT_AGGRID_COLORS.altRowBackground,
    },
  })

export const InputContainer = styled(FlexContainer)({
  height: "100%",
})

export const BookText = styled(MediumText)({
  padding: "6px 0 0 4px",
  color: SCIENT_COLORS.gray4,
})

export const CellText = styled(SmallText)({
  padding: "8px 0 0 0",
  color: SCIENT_COLORS.gray4,
})

export const SideRowCell = styled(RowCell)<{ side?: Side }>(({ side }) => ({
  backgroundColor: getOrderSideBackgroundColor(side),
}))

export const sideSelectCss = (side?: Side) =>
  css({
    color: `${SCIENT_COLORS.white} !important`,
    fontWeight: 600,
    backgroundColor: "transparent",

    // Blueprint HTMLSelect specific overrides
    ".bp5-html-select select": {
      color: `${SCIENT_COLORS.white} !important`,
      backgroundColor: "transparent !important",
      fontWeight: 600,
    },
    ".bp5-html-select .bp5-icon": {
      color: `${SCIENT_COLORS.white} !important`,
    },

    // Disabled state remains readable
    "select.bp5-disabled, select[disabled]": {
      color: `${SCIENT_COLORS.white} !important`,
      opacity: 0.85,
    },
    // Remove default focus ring/background that may clash
    ":focus": {
      outline: "none",
      boxShadow: "none",
    },
  })
